// @flow

import React from 'react';
import bemify from 'bemify-js';

import { serviceUtils } from '@zapier/common-utils';

type LogoImageProps = {
  logoSize: 16 | 32 | 64 | 128,
  logoClass: string,
  className?: string,

  // Hack to be able to turn off stupid 'app-logo' class, which should really be in container not this component.
  // Too much cruft to change, so optionally turn it off with `isAppLogo={false}` but default to true.
  isAppLogo: boolean,
};

/*
   Displays app logo all purty like.
 */
const LogoImage = (props: LogoImageProps) => {
  const { className, isAppLogo, logoClass: logoClx, logoSize: size } = props;

  const sizeXsize = `${size}x${size}`;
  const logoClass = serviceUtils.stripVersion(logoClx);
  const appLogoClass = isAppLogo ? 'app-logo' : '';
  const classes = bemify(
    '',
    appLogoClass,
    `img${size}`,
    `PlaceholderAPI${sizeXsize}`,
    `${logoClass}${sizeXsize}`,
    className
  );

  return <div className={classes} />;
};

LogoImage.defaultProps = {
  logoSize: 128,
  className: '',
  isAppLogo: true,
};

export default LogoImage;
